import { render } from "./ProjectTracking.vue?vue&type=template&id=2c2bd834&scoped=true"
import script from "./ProjectTracking.vue?vue&type=script&lang=js"
export * from "./ProjectTracking.vue?vue&type=script&lang=js"

import "./ProjectTracking.vue?vue&type=style&index=0&id=2c2bd834&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2bd834"]])

export default __exports__